import { api } from './api';
import { BillingSummary, BillingDetail } from '../types/billing';

export const billingService = {
  async getBillingList(userId: string | number): Promise<BillingSummary[]> {
    const { data } = await api.get<BillingSummary[]>(`/billing/list/${userId}`);
    return data;
  },

  async getBillingDetail(userId: string | number, ledgerNumber: string): Promise<BillingDetail[]> {
    const { data } = await api.get<BillingDetail[]>(`/billing/detail/${userId}/${ledgerNumber}`);
    return data;
  },

  async downloadPdf(userId: string | number, ledgerNumber: string): Promise<Blob> {
    const { data } = await api.get(`/billing/pdf/${userId}/${ledgerNumber}`, {
      responseType: 'blob',
    });
    return data;
  },

  async exportExcel(userId: string | number, ledgerNumber: string): Promise<Blob> {
    const { data } = await api.get(`/billing/export/${userId}/${ledgerNumber}`, {
      responseType: 'blob',
    });
    return data;
  }
};
